import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { ApiService } from '../../api.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  form: FormGroup;
  inputType = 'password';
  showPassword = false;


  constructor(
    private router: Router,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private apiService: ApiService,
  ) {
    this.form = this.fb.group({
      UserName: ['', Validators.required],
      Email: ['', [Validators.required, Validators.email]],
      Password: ['', Validators.required],
      Terms  : ['', Validators.required]
      // Terms: [false, Validators.requiredTrue] 
     });
  }

  ngOnInit(): void {
  }




  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  onSubmit() {
    console.log('=== FRONTEND: onSubmit() called ===');
    console.log('Form valid:', this.form.valid);
    console.log('Form value:', this.form.value);
    
    if (this.form.valid) {
      // Map frontend form fields to backend requirements
      const userData = this.mapFormDataToBackend(this.form.value);
      console.log('=== FRONTEND: Sending data to backend ===');
      console.log('Mapped userData:', userData);
      console.log('API endpoint: /api/adduser');
      
      this.apiService.register(userData).subscribe(
        response => {
          console.log('=== FRONTEND: Backend response received ===');
          console.log('Success response:', response);
          alert('User registered successfully!');
          // Reset form and redirect to login
          this.form.reset();
          this.router.navigate(['/login']);
        },
        error => {
          console.log('=== FRONTEND: Backend error received ===');
          console.error('Error response:', error);
          console.error('Error details:', error.error);
          alert('Registration failed: ' + (error.error?.message || 'Please try again.'));
        }
      );
    } else {
      console.log('=== FRONTEND: Form validation failed ===');
      console.log('Form errors:', this.form.errors);
      alert('Please fill in all required fields.');
    }
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.onSubmit();
    }
  }

  // Function to map frontend form data to backend requirements
  private mapFormDataToBackend(formData: any): any {
    console.log('=== FRONTEND: mapFormDataToBackend() called ===');
    console.log('Input formData:', formData);
    
    // Extract first and last name from username (assuming format: "FirstName LastName")
    const nameParts = (formData.UserName || '').trim().split(' ');
    const firstName = nameParts[0] || '';
    const lastName = nameParts.slice(1).join(' ') || '';
    
    console.log('Extracted names - firstName:', firstName, 'lastName:', lastName);

    // Map frontend fields to backend format with default values
    const backendData = {
      first_name: firstName,
      last_name: lastName,
      email: formData.Email || '',
      mobile: '0000000000', // Default mobile number since not in frontend form
      designation: 'CRC', // Default designation since not in frontend form
      site_location: 'Main Site', // Default site location
      site_city: 'New York', // Default city
      site_state: 'NY', // Default state
      site_country: 'USA' // Default country
    };

    console.log('=== FRONTEND: Final backend data ===');
    console.log('Mapped data for backend:', backendData);
    return backendData;
  }
  


  


}
